import { render, staticRenderFns } from "./SkupBase.vue?vue&type=template&id=1cba7f08&scoped=true&"
import script from "./SkupBase.vue?vue&type=script&lang=js&"
export * from "./SkupBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cba7f08",
  null
  
)

export default component.exports